import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ListService } from '../../ajs-upgraded-providers';
import { EntityType } from '../../rl-common/shared/shared/entity-type.enum';
import { DeeplinkConfig } from '../shared/deeplink-config';


@Injectable({
  providedIn: 'root'
})
export class LTIDeeplinkingService {

  constructor(private http : HttpClient, private listService: ListService) { }

  embedItems(config : DeeplinkConfig, citationIds: any[], list: any) {

    var data = this.prepareData(config, citationIds, list);

    this.http.post<any>('../rl/lti/citationsEmbed', data).subscribe(data => this.submitData(data));
  };
  
  prepareData(config : DeeplinkConfig, citationIds: any[], list: any) {
    var data = {
      "items" : [], 
      "config" : {
        "type"          : config.selectType,
        "openInNewTab"  : (config.embedMode == "brief"),
        "displayStyle"  : config.displayStyle.value,
        "linkTitle"     : config.linkLabel
      }
    };

    var citations = this.listService.getCitationsFromListByIds(list, citationIds);
		
		for (var i = 0 ; i < citations.length; i++) {
			
			var item = {
				"type" : "CITATION",
				"id" : citations[i].id, 
				"thumbnail" : citations[i].thumbnail
			};

			data.items[data.items.length] = item;
		}

    return data;
  }

  link = (type : EntityType, data : any) => this.http.post<any>(`../rl/lti/${type}/link`, data).subscribe(res => this.submitData(res));
  links = (data : any) => this.http.post<any>(`../rl/lti/links`, data).subscribe(res => this.submitData(res));
  
  submitData(data : {action : string, jwt : string}){
    var body = document.getElementById("indexBody");

    var form = document.createElement("form");
    form.setAttribute("method", "post"); 
    form.setAttribute("action", data.action); 
      
    var input = document.createElement("input");
    input.setAttribute("name", "JWT"); 
    input.setAttribute("value", data.jwt); 
  
    form.appendChild(input);
    body.appendChild(form);
    form.submit();
  }
}
